import L from 'leaflet';
import { useEffect, useState } from 'react';
import { defaultOptions } from '../constants';
import Converter from '../converter';
const getWeight = (options) => (options && options.weight ? options.weight : defaultOptions.weight) +
    (options && options.tolerance ? options.tolerance : defaultOptions.tolerance);
function useEventPolylines(map, hotline, data, getLat, getLng, options, eventHandlers) {
    const [polylines, setPolylines] = useState([]);
    const poylineOptions = {
        color: 'red',
        weight: getWeight(options),
        opacity: 0,
    };
    const createPolyline = (latlngs, segment) => {
        const polyline = L.polyline(latlngs, poylineOptions);
        attachEventHandlers(polyline, segment);
        return polyline.addTo(map);
    };
    const attachEventHandlers = (polyline, line) => {
        if (eventHandlers === undefined)
            return;
        Object.entries(eventHandlers).forEach(([k, v]) => {
            polyline.on(k, (e) => v({ event: e, line, polyline }));
        });
    };
    useEffect(() => {
        if (eventHandlers === undefined || hotline === undefined)
            return;
        const coords = Converter.toLatLngs(data, getLat, getLng, () => 0);
        const _polylines = coords.map((c, i) => createPolyline(c, i));
        setPolylines(_polylines);
        return () => {
            _polylines.forEach((p) => p.remove());
        };
    }, [data, hotline]);
    useEffect(() => {
        if (polylines === undefined)
            return;
        polylines.forEach(attachEventHandlers);
    }, [eventHandlers]);
    return null;
}
export default useEventPolylines;
